@if (task() && task()?.taskType()) {
  <proffeo-task-details-actions-menu
    #actionsMenu
    (subtaskCreationRequested)="startSubtaskCreation()"
    (taskFilesAdded)="onFilesAdded($event, FileContext.taskFile)"
    [task]="task()"
    class="contents"
  />

  @if (isMobile()) {
    <proffeo-task-details-mobile-screen
      (closeRequested)="onPanelClosed()"
      (nameEditCancelled)="onNameEditCancelled()"
      (nameEditRequested)="onNameEditRequested()"
      (tabSelected)="onScreenTabSelected($event)"
      (taskNameChanged)="onTaskNameChanged($event)"
      (taskTypeSelected)="onTaskTypeSelected($event)"
      (timeReportRequested)="openTimeReportDialog($event)"
      (timeReportsTabRequested)="onTimeReportsTabRequested()"
      [currentTabIndex]="currentTabIndex()"
      [isNameEditing]="isNameEditing()"
      [maxTaskNameLength]="MAX_TASK_NAME_LENGTH"
      [subtasksContent]="subtasksSection"
      [tabContent]="tabContent"
      [taskActionsMenu]="actionsMenu.taskActionsMenu()"
      [taskTypes]="activeCompanyTaskTypes()"
      [task]="task()"
    />
  } @else {
    <proffeo-task-details-wide-screen
      (activityReopenRequested)="onReopenActivity()"
      (closeRequested)="onPanelClosed()"
      (nameEditCancelled)="onNameEditCancelled()"
      (nameEditRequested)="onNameEditRequested()"
      (tabSelected)="onScreenTabSelected($event)"
      (taskNameChanged)="onTaskNameChanged($event)"
      (taskTypeSelected)="onTaskTypeSelected($event)"
      (timeReportRequested)="openTimeReportDialog($event)"
      (timeReportsTabRequested)="onTimeReportsTabRequested()"
      [currentTabIndex]="currentTabIndex()"
      [isNameEditing]="isNameEditing()"
      [maxTaskNameLength]="MAX_TASK_NAME_LENGTH"
      [showReopenActivity]="showReopenActivity()"
      [subtasksContent]="subtasksSection"
      [tabContent]="tabContent"
      [taskActionsMenu]="actionsMenu.taskActionsMenu()"
      [taskTypes]="activeCompanyTaskTypes()"
      [task]="task()"
    />
  }
}

<ng-template #tabContent>
  @switch (currentTabIndex()) {
    @case (TaskDetailsTab.Description) {
      <proffeo-task-details-description-tab
        (avatarSet)="onSetFileAsAvatar($event)"
        (descriptionChange)="changeDescription($event)"
        (descriptionFilesAdded)="onFilesAdded($event, FileContext.taskDescriptionFile)"
        (fileDelete)="onFileDelete($event, FileContext.taskDescriptionFile)"
        (unsavedChangesChange)="onDescriptionUnsavedChangesChange($event)"
        [descriptionFiles]="descriptionFiles()"
        [activeUploads]="activeUploads()"
        [descriptionHasUnsavedChanges]="descriptionHasUnsavedChanges()"
        [taskParticipants]="taskParticipants()"
        [task]="task()"
      />
    }
    @case (TaskDetailsTab.Files) {
      <proffeo-task-details-files-tab
        (avatarSet)="onSetFileAsAvatar($event)"
        (fileDelete)="onFileDelete($event, FileContext.taskFile)"
        (filesAdded)="onFilesAdded($event, FileContext.taskFile)"
        [activeUploads]="activeUploads()"
        [files]="files()"
        [task]="task()"
      />
    }
    @case (TaskDetailsTab.TimeReports) {
      <proffeo-task-details-time-reports-tab
        [isActive]="currentTabIndex() === TaskDetailsTab.TimeReports"
        [task]="task()"
      />
    }
    @case (TaskDetailsTab.PrivateNotes) {
      <proffeo-task-details-private-notes-tab />
    }
  }
</ng-template>

<ng-template #subtasksSection>
  <proffeo-task-details-subtasks-section
    (addSubtaskFromPanel)="onAddSubtaskFromPanelClick($event)"
    (addTimeReport)="openTimeReportDialog($event)"
    (desktopPanelExpandedChange)="onDesktopSubtasksPanelExpandedChange($event)"
    (priorityChanged)="onPrioritySelected($event.priority, $event.subtask)"
    (progressChanged)="onProgressSelected($event.percentage, $event.subtask)"
    (statusChanged)="onStatusSelected($event.status, $event.subtask)"
    (subtaskClick)="onSubtaskClick($event)"
    [isMobile]="isMobile()"
    [isTaskSubtasksPanelContentVisible]="isTaskSubtasksPanelContentVisible()"
    [showTaskSubtasksPanel]="showTaskSubtasksPanel()"
    [subtasks]="activeTaskSubtasks() ?? []"
    [task]="task()"
  />
</ng-template>
